<template>

  <v-layout align-center justify-center column fill-height>
    <v-icon color="grey">snooze</v-icon>

    <h4>{{ $t('idle') }}</h4>
  </v-layout>

</template>

<script>
  export default {
    name: 'state-idle'
  }
</script>

<style scoped lang="scss">

</style>
